<script>
import bnFormMixin from '@/components/BnFormMixin';

export default {
    name: 'BnFormGoogleaddressText',
    extends: bnFormMixin,
    props: {
        modelValue: [String, Number, Object],
    },
    emits: ['update:modelValue', 'placeChanged'],
    data() {
        return {
            items: [],
            search: null,
            menu: null,
        };
    },
    watch: {
        search() {
            // if (this.search === this.modelValue) {
            //     this.menu = false;
            //     return;
            // }
            this.googleSearch();
        },
    },
    methods: {
        updateValue: function (value) {
            this.$emit('update:modelValue', value);
        },
        chooseAddress: function (inputValue) {
            this.menu = false;

            // Use Places API getDetails instead of Geocoding API
            const service = new google.maps.places.PlacesService(document.createElement('div'));
            const request = {
                placeId: inputValue.raw?.place_id,
                fields: ['address_components', 'geometry'],
            };

            service.getDetails(request, (place, status) => {
                if (status !== google.maps.places.PlacesServiceStatus.OK) {
                    console.error('Places API error:', status);
                    return;
                }

                let addressNumber = this.getAcTypeValue(place.address_components, 'street_number', 'short_name');
                let addressStreet = this.getAcTypeValue(place.address_components, 'route', 'long_name');

                let address = {};
                address.line1 = ((addressNumber ? addressNumber + ' ' : '') + (addressStreet ? addressStreet : '')).trim();
                address.line2 = '';
                address.city = this.getAcTypeValue(place.address_components, 'locality', 'long_name');
                address.state = this.getAcTypeValue(place.address_components, 'administrative_area_level_1', 'short_name');
                address.stateLong = this.getAcTypeValue(place.address_components, 'administrative_area_level_1', 'long_name');
                address.postalCode = this.getAcTypeValue(place.address_components, 'postal_code', 'short_name');
                address.country = this.getAcTypeValue(place.address_components, 'country', 'short_name');
                address.geometry = place.geometry;

                this.$emit('update:modelValue', address.line1);
                this.$emit('placeChanged', address);

                this.$nextTick(() => (this.menu = false));
            });
        },
        googleSearch() {
            const service = new google.maps.places.AutocompleteService();
            service.getPlacePredictions({ input: this.search, locationBias: 'IP_BIAS', types: ['geocode'] }, (predictions) => {
                if (!predictions?.length) return;

                this.items = predictions.map((item) => {
                    return {
                        title: item.description,
                        place_id: item.place_id,
                    };
                });
            });
        },
        getAcTypeValue: function (addressComponents, searchType, valueType) {
            let componentPart = addressComponents?.find((element) => {
                return element.types[0] === searchType;
            });

            return componentPart ? componentPart[valueType.toString()] : '';
        },
    },
};
</script>

<template>
    <v-combobox
        :id="id"
        ref="bnGoogleAddressAutoComplete"
        v-bind="$attrs"
        v-model:search="search"
        v-model:menu="menu"
        data-cy="googleAddress"
        label="Line 1"
        :model-value="modelValue"
        :items="items"
        autocomplete="off"
        :filter="(d) => d"
        return-object
        @update:model-value="updateValue"
    >
        <template #item="{ props, item }">
            <v-list-item v-bind="props" :title="item?.title" @click="chooseAddress(item)"></v-list-item>
        </template>
    </v-combobox>
</template>
